import React from 'react';
import { Box, Stack, Typography } from '@mui/material';


const Level = ({ levelDetails, sx }) => (
  <Box
    display="flex"
    justifyContent="flex-start"
    alignItems="center"
    pl={1}
    pr={1}
    sx={{
      backgroundColor: levelDetails.color,
      border: '2px solid',
      borderColor: levelDetails.color !== 'white' ? levelDetails.color : 'black',
      borderRadius: '8px',
      width: '250px',
      ...sx
    }}
  >
    <Typography style={{ color: levelDetails.color !== 'white' ? 'white' : 'black' }} variant="subtitle1">{levelDetails.label}</Typography>
    <Box flex={1}></Box>
    <Stack sx={{ alignSelf: 'stretch' }} direction="row" alignItems="stretch" spacing={1}>
      {[...Array(levelDetails.stripes)].map((_, i) => <Box key={i} width={4} style={{ backgroundColor: levelDetails.stripe_color }}></Box>)}
    </Stack>
  </Box>
);

export default Level;
